var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.context.request.user.is_staff ? _vm._m(0) : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass:
          "text-caption-2 px-2 py-1 rounded d-inline-block bg-admin cursor-pointer",
      },
      [_vm._t("default")],
      2
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }